// extracted by mini-css-extract-plugin
export default {"header":"Confirm_header__eQ3HI","readings":"Confirm_readings__574jY","reading":"Confirm_reading__wCEDf","readingPct":"Confirm_readingPct__zQv4B"};